import styled from "styled-components";

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 18px;
  width: -webkit-fill-available;
`;

export const Alternative = styled.label`
  display: flex;
  align-items: center;
  min-height: 30px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.colors.text.default};
  margin-bottom: 8.33px;
`;

export const Question = styled.label`
  display: flex;
  align-items: center;
  min-height: 30px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.colors.text.default};
  margin-bottom: 8px;
`;

export const TitleWrapper = styled.section`
  display: flex;
  align-items: center;
  margin: 8.33px 0;
`;

export const Title = styled.h3`
  margin: 0;
  padding-left: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #a1b4c4;
`;

export const ItemsEmpty = styled.div`
  padding: 0px 24px;
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100px;
`;